import React from 'react'

const RecommendationCard = ({ recom: { name, image, position_company, recommendation } }) => {
    return (
        <div className="item">
            <div className="revs-item">
                <div className="text">
                    {recommendation}
                </div>
                <div className="user">
                    <div className="img"><img src={image} alt="" /></div>
                    <div className="info">
                        <div className="name"> {name}</div>
                        <div className="company">{position_company}</div>
                    </div>
                    <div className="clear"></div>
                </div>
            </div>
        </div>
    );
}

export default RecommendationCard;